import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardExtrasExplainerModal',
})

export default class CmgRewardExtrasExplainerModal extends Vue {

  get visible() {
    return this.$appStore.state.ui.modals.rewardExtrasExplainer.visible;
  }

  get imgUrl(): string {
    return this.$appStore.state.cms.images.icons.aboutExtras.default;
  }
  
  get explanation(): string {
    return 'As a Chipotle Rewards Member, you have access to special offers. Extras are a chance to earn even more points on top of your Rewards points.';
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  onClose() {
    this.$services.ui.setModalVisibility('rewardExtrasExplainer', false);
  }

}